import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const StyledNavigationMain = styled.ul({
	[breakpoints.lg]: {
		display: 'flex',
		gap: 2,
	},
});
